import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ButtonBase from '@mui/material/ButtonBase';
import { Button, Chip, colors } from '@mui/material';
import { createLabelSVG } from 'features/Mobile/utils';
import { useIntl } from 'react-intl';
import { CartItem } from 'components/Cart/Cart';
import { useMobileContext } from 'context/mobile/mobileContext';

type ProductPreviewProps = CartItem & {
  dateTime: Date,
  quantity: number;
  onRemove?: Function;
  onEdit?: Function;
}

export default function ProductPreview(product: ProductPreviewProps) {
  const { brand, pic } = useMobileContext();
  const { heading, quantity, onRemove, onEdit, dateTime } = product;
  const intl = useIntl();

  return (
    <Box sx={{ py: '16px', margin: 'auto', maxWidth: 500, flexGrow: 1 }}>
      <Grid container spacing={2}>
        <Grid item>
          <ButtonBase sx={{ width: 200, height: '110px', border: '1px solid black' }}>
            {createLabelSVG({
              brand,
              pic,
              productHeading: product.heading,
              productSubheading: product.subHeading,
              dateTime,
              calculationReady: product.calculationReady,
              calculationDiscard: product.calculationDiscard,
              dateDiscard: product.discardDate,
              locale: intl.locale,
              picText: intl.formatMessage({ id: 'label.pic.title' }),
              madeText: intl.formatMessage({ id: 'label.made.title' }),
              readyText: intl.formatMessage({ id: 'label.ready.title' }),
              discardText: intl.formatMessage({ id: 'label.discard.title' }),
            })}
          </ButtonBase>
        </Grid>
        <Grid item xs container>
          <Grid item xs container direction="column" spacing={2}>
            <Grid item xs>
              <Typography variant="body2" component="div">
                {heading}
              </Typography>
            </Grid>
            {quantity && (
              <Box>
                <Chip label={quantity} sx={{ borderRadius: 1, marginRight: '12px', marginLeft: '12px' }} />
                <Typography component={'span'} sx={{ display: 'inline-block', fontSize: '12px', color: colors.grey[700] }}>
                  {intl.formatMessage({ id: 'mobile.heading.quantity' }, { quantity })}
                </Typography>
              </Box>
            )}
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              {onEdit && (
                <Button
                  sx={{ color: colors.red, padding: 0, fontSize: '12px' }}
                  onClick={() => onEdit()}>
                  {intl.formatMessage({ id: 'mobile.button.edit.title' })}
                </Button>
              )}
              {onRemove && (
                <Button
                  sx={{ padding: 0, fontSize: '12px', color: colors.grey[700] }}
                  onClick={() => onRemove && onRemove({ ...product })}>
                  {intl.formatMessage({ id: 'mobile.button.delete.title' })}
                </Button>
              )}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
